import collections from './collections/index.js';

export default {

    backend: {
        name: 'github',
        repo: 'rivo-tuksammel/casabella',
        branch: 'startlight',
        base_url: 'https://oauth.parukad.ee'
    },
    load_config_file: false,
    media_folder: "/public/assets",
    public_folder: "/assets",
    collections: collections,
}